var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{on:{"close":_vm.close}},[_c('div',{staticClass:"lock"},_vm._l((_vm.input),function(digit,i){return _c('LockDigit',{key:i,attrs:{"disabled":_vm.disabled},on:{"update":function($event){return _vm.update($event, i)}}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }